import * as z from "zod";

export const ProspectFormSchema = z.object({
  companyName: z
    .string()
    .min(3, {
      message: "Company name is required. Minimum length is 3 characters",
    })
    .max(36, {
      message: "Maximum length is 36 characters.",
    })
    .regex(
      new RegExp(/^[a-zA-Z\s]+$/),
      "Company name cannot contain special characters."
    ),
  jobTitle: z
    .string()
    .min(2, {
      message: "Job title is required. Minimum length is 2 characters",
    })
    .max(40, {
      message: "Maximum length is 40 characters.",
    }),
  firstName: z
    .string()
    .regex(new RegExp(/^[a-zA-Z\s]+$/), "Invalid format for firstname")
    .refine((val) => val.replaceAll(" ", "").length >= 3, {
      message: "First name is required. Minimum length is 3 characters",
    })
    .refine((val) => val.replaceAll(" ", "").length < 20, {
      message: "Minimum length is 20 characters",
    }),
  lastName: z
    .string()
    .regex(new RegExp(/^[a-zA-Z\s]+$/), "Invalid format for lastname")
    .refine((val) => val.replaceAll(" ", "").length >= 1, {
      message: "Last name is required.",
    })
    .refine((val) => val.replaceAll(" ", "").length < 20, {
      message: "Minimum length is 20 characters",
    }),
  phoneNumber: z.string().min(5, { message: "Phone number is required." }),
  email: z.string().trim().email("Invalid email address").max(40, {
    message: "Maximum length is 40 characters.",
  }),
});

export type ProspectFormType = z.infer<typeof ProspectFormSchema>;
